import { Email } from '@/modules/profiles/types'
import { Loader, SupportedLocale } from 'kiswe-ui'

export type ParticipantInfoRequiredKeys = keyof Pick<ParticipantInfo, 'firstName' | 'lastName' | 'email' | 'relation'>

export class ParticipantInfo {
  firstName: string = ''
  lastName: string = ''
  email: Email|null = null
  countryCode: string|null = null
  phoneNumber: string|null = null
  relation: string|null = null
  language: SupportedLocale = SupportedLocale.English
  deleted: boolean = false
  notes: string = ''
  lastCheckedIn: Date = new Date()

  constructor (data?: unknown) {
    if (!data) return
    this.firstName = Loader.loadString(data, 'firstName', this.firstName)
    this.lastName = Loader.loadString(data, 'lastName', this.lastName)
    this.email = Loader.loadStringOrNull(data, 'email', this.email) as Email|null
    this.countryCode = Loader.loadStringOrNull(data, 'countryCode', this.countryCode)
    this.phoneNumber = Loader.loadStringOrNull(data, 'phoneNumber', this.phoneNumber)
    this.language = Loader.loadEnum(data, 'language', SupportedLocale.English, Object.values(SupportedLocale))
    this.relation = Loader.loadStringOrNull(data, 'relation', this.relation)
    this.deleted = Loader.loadBoolean(data, 'deleted', false)
    this.notes = Loader.loadString(data, 'notes', this.notes)
    this.lastCheckedIn = Loader.loadDate(data, 'lastCheckedIn', this.lastCheckedIn)
  }

  get requiredKeys (): ParticipantInfoRequiredKeys[] {
    return ['firstName', 'lastName', 'email', 'relation']
  }

  get hasAllRequiredInfo (): boolean {
    return this.requiredKeys.every((key) => !!this[key])
  }

  get name (): string {
    return `${this.firstName} ${this.lastName}`.trim()
  }

  /** @deprecated Use firstName and lastName instead */
  set name (newVal: string) {
    const parts = newVal.split(' ')
    this.firstName = parts.shift() ?? ''
    this.lastName = parts.join(' ') ?? ''
  }
}
